import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import React, { useEffect, useRef, useState } from 'react';
import { StateModel } from '../../../../redux/store';
import { connect } from 'react-redux';
import { getServerLog } from '../../../../redux/actions/admin';
import Button from '../../../../components/button/Button';
import { setNotification } from '../../../../utils/notificationUtils';

interface ServerlogProps {
  log: string;
  reloadServerlog: boolean;
  getServerLog: () => void;
}

const Serverlog = (props: ServerlogProps) => {
  const [logtext, setLogtext] = useState(' Lorem ipsum...');

  useEffect(() => {
    setLogtext(props.log);
  }, [props.reloadServerlog]);

  const aktualisieren = () => {
    props.getServerLog();
  };
  const clear = () => {
    setLogtext('');
  };

  const copy = () => {
    navigator.clipboard.writeText(props.log).then(value => {
      setNotification('Serverlog wurde in die Zwischenablage kopiert', []);
    });
  };

  const endOfLog = useRef<HTMLLIElement>(null);
  const logbuch = useRef<HTMLLIElement>(null);
  const scrollSmoothHandler = () => {
    const eol = endOfLog.current;
    if (eol != null) eol.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <GridCellWrapper
      classes='admin-log'
      label='Serverlog'
      saveUserAnsicht={() => {
        null;
      }}
    >
      <div className={'admin-buttons'}>
        <Button classes={'iconbutton'} onClickHandler={aktualisieren}>
          aktualisieren
        </Button>
        <Button
          onClickHandler={scrollSmoothHandler}
          tooltip={'ans Ende scrollen'}
        >
          <i className='fas fa-skiing'></i>
        </Button>

        <Button classes={'iconbutton'} onClickHandler={clear}>
          leeren
        </Button>
      </div>
      <div className='serverlog-scroll'>
        <ul>
          <li>{logtext}</li>
          <li ref={endOfLog}></li>
        </ul>
      </div>
    </GridCellWrapper>
  );
};
const mapStateToProps = (state: StateModel) => ({
  log: state.Admin.log,
  reloadServerlog: state.Admin.reloadServerlog,
});

export default connect(mapStateToProps, {
  getServerLog,
})(Serverlog);
